import React from 'react';
import { Typography } from '@mui/material';

export const OrdersListBanner = () => (
  <Typography>
    In October 2024, HistoWiz launched Block Manager, which allows you to see
    all of your blocks in real time. All new orders placed will receive two
    months of complementary storage. Blocks still in storage after those two
    months, will incur a monthly charge of $0.99/block. If you do not wish to
    have your blocks stored on the Block Manager and would like to have your
    blocks returned, please click the “ship back blocks” button. If you have
    orders from before October 2024 that you would like shipped back, you will
    be prompted to{' '}
    <a
      target="_blank"
      href="https://features.histowiz.com/request-back-blocks"
      rel="noreferrer"
    >
      fill out a form for the request
    </a>
    . This form only needs to be completed once for all requested materials.
    Once complete, a member of our logistics team will reach out to you with
    shipment details and confirmation.
  </Typography>
);
